/* ============================================
   YMM Product Wizard — JavaScript
   ============================================ */
(function () {
  'use strict';

  var root = document.getElementById('ymm-wizard');
  if (!root) return;

  var productId = root.dataset.productId || '0';
  var STORAGE_KEY = 'ymm_wizard_' + productId;

  /* ── State ── */
  var state = {
    step: 1,
    occasion: null,
    occasionEmoji: '',
    customOccasion: '',
    name: '',
    lang: 'Nederlands',
    genre: null,
    customGenre: '',
    showCustomGenre: false,
    voice: null,
    story: '',
    extras: '',
    express: false,
    version: false,
    wav: false,
    email: ''
  };

  var isSubmitting = false;

  /* ── Restore from sessionStorage ── */
  try {
    var saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      var parsed = JSON.parse(saved);
      for (var k in parsed) {
        if (state.hasOwnProperty(k)) state[k] = parsed[k];
      }
    }
  } catch (e) { /* ignore */ }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) { /* ignore */ }
  }

  /* ── DOM References ── */
  var steps = root.querySelectorAll('.ymm-step');
  var progressSteps = root.querySelectorAll('.ymm-progress__step');
  var progressLines = root.querySelectorAll('.ymm-progress__line');
  var ctaBtn = document.getElementById('ymm-cta-btn');
  var errorMsg = document.getElementById('ymm-error-msg');
  var cardEl = root.querySelector('.ymm-wizard-card');

  /* Step 1 */
  var occasionChips = root.querySelectorAll('[data-occasion]');
  var moreBtn = root.querySelector('[data-toggle="more-occasions"]');
  var moreWrap = root.querySelector('.ymm-more-occasions');
  var customOccasionWrap = root.querySelector('.ymm-custom-occasion');
  var customOccasionInput = root.querySelector('[data-input="custom-occasion"]');
  var nameInput = root.querySelector('[data-input="name"]');

  /* Step 2 */
  var langChips = root.querySelectorAll('[data-lang]');
  var genreChips = root.querySelectorAll('[data-genre]');
  var customGenreBtn = root.querySelector('[data-toggle="custom-genre"]');
  var customGenreWrap = root.querySelector('.ymm-custom-genre');
  var customGenreInput = root.querySelector('[data-input="custom-genre"]');
  var voiceChips = root.querySelectorAll('[data-voice]');
  var audioPlayer = root.querySelector('.ymm-audio-player');
  var audioFallback = root.querySelector('.ymm-audio-fallback');
  var audioEl = root.querySelector('#ymm-audio');
  var audioPlayBtn = root.querySelector('.ymm-audio__play');
  var audioBarFill = root.querySelector('.ymm-audio__bar-fill');
  var audioTime = root.querySelector('.ymm-audio__time');
  var audioGenreName = root.querySelector('.ymm-audio__genre-name');

  /* Step 3 */
  var storyInput = root.querySelector('[data-input="story"]');
  var charCount = root.querySelector('.ymm-char-count');
  var extrasBtn = root.querySelector('[data-toggle="extras"]');
  var extrasWrap = root.querySelector('.ymm-extras-wrap');
  var extrasInput = root.querySelector('[data-input="extras"]');

  /* Step 4 */
  var summaryIcon = root.querySelector('.ymm-summary__icon');
  var summaryTitle = root.querySelector('.ymm-summary__title');
  var summaryDetails = root.querySelector('.ymm-summary__details');
  var summaryStory = root.querySelector('.ymm-summary__story');
  var basePrice = root.querySelector('[data-price="base"]');
  var bumpBtns = root.querySelectorAll('[data-bump]');
  var totalAmount = root.querySelector('.ymm-total-line__amount');
  var emailInput = root.querySelector('[data-input="email"]');

  /* ── Occasions Map ── */
  var occasionEmojis = {};
  occasionChips.forEach(function (c) {
    occasionEmojis[c.dataset.occasion] = c.querySelector('.ymm-chip__emoji').textContent.trim();
  });

  /* ── Step Navigation ── */
  function goToStep(newStep, direction) {
    if (newStep < 1 || newStep > 4) return;
    if (newStep === state.step) return;

    /* Stop audio when leaving step 2 */
    if (state.step === 2) stopAudio();

    /* Clear pending debounce timer */
    clearTimeout(charTimer);

    var dir = direction || (newStep > state.step ? 'forward' : 'back');
    var currentEl = steps[state.step - 1];
    var nextEl = steps[newStep - 1];

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      currentEl.classList.remove('ymm-step--active');
      nextEl.classList.add('ymm-step--active');
    } else {
      /* Exit current */
      currentEl.classList.add('ymm-step--animate');
      currentEl.classList.add(dir === 'forward' ? 'ymm-step--exit-left' : 'ymm-step--exit-right');

      setTimeout(function () {
        currentEl.classList.remove('ymm-step--active', 'ymm-step--animate', 'ymm-step--exit-left', 'ymm-step--exit-right');

        /* Enter next */
        nextEl.classList.add(dir === 'forward' ? 'ymm-step--enter-right' : 'ymm-step--enter-left');
        nextEl.classList.add('ymm-step--active');

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            nextEl.classList.add('ymm-step--animate');
            nextEl.classList.remove('ymm-step--enter-right', 'ymm-step--enter-left');

            setTimeout(function () {
              nextEl.classList.remove('ymm-step--animate');
            }, 280);
          });
        });
      }, 260);
    }

    state.step = newStep;
    saveState();
    updateProgress();
    updateCTA();
    updateCard();

    if (newStep === 4) updateSummary();

    /* Scroll to top of wizard on step change */
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });

    /* Focus management */
    setTimeout(function () {
      var firstFocusable = nextEl.querySelector('button, input, textarea, [tabindex="0"]');
      if (firstFocusable) firstFocusable.focus({ preventScroll: true });
    }, reducedMotion ? 50 : 310);
  }

  function updateProgress() {
    progressSteps.forEach(function (el, i) {
      var stepNum = i + 1;
      el.classList.remove('ymm-progress__step--completed', 'ymm-progress__step--current');
      el.removeAttribute('aria-current');
      el.dataset.clickable = 'false';

      if (stepNum < state.step) {
        el.classList.add('ymm-progress__step--completed');
        el.querySelector('.ymm-progress__circle').textContent = '\u2713';
        el.dataset.clickable = 'true';
      } else if (stepNum === state.step) {
        el.classList.add('ymm-progress__step--current');
        el.querySelector('.ymm-progress__circle').textContent = stepNum;
        el.setAttribute('aria-current', 'step');
      } else {
        el.querySelector('.ymm-progress__circle').textContent = stepNum;
      }
    });

    progressLines.forEach(function (el, i) {
      el.classList.toggle('ymm-progress__line--completed', i + 1 < state.step);
    });
  }

  function updateCard() {
    if (cardEl) {
      cardEl.classList.toggle('ymm-wizard-card--step4', state.step === 4);
    }
  }

  /* ── Validation ── */
  function isStepValid(step) {
    switch (step) {
      case 1:
        var occasionOk = state.occasion !== null;
        if (state.occasion === 'Anders') occasionOk = state.customOccasion.trim().length > 0;
        return occasionOk && state.name.trim().length > 0;
      case 2:
        var genreOk = state.genre !== null || (state.showCustomGenre && state.customGenre.trim().length > 0);
        return genreOk && state.voice !== null;
      case 3:
        return state.story.trim().length >= 20;
      case 4:
        var e = state.email.trim();
        var at = e.indexOf('@');
        var dot = e.lastIndexOf('.');
        return at > 0 && dot > at + 1 && dot < e.length - 1;
      default:
        return false;
    }
  }

  function updateCTA() {
    var valid = isStepValid(state.step);

    if (state.step === 4) {
      var total = calcTotal();
      ctaBtn.textContent = 'Bestel nu \u2014 \u20AC' + formatPrice(total);
      ctaBtn.className = 'ymm-cta-btn ymm-cta-btn--active';
    } else {
      ctaBtn.textContent = 'Volgende \u2192';
      if (valid) {
        ctaBtn.className = 'ymm-cta-btn ymm-cta-btn--active';
      } else {
        ctaBtn.className = 'ymm-cta-btn ymm-cta-btn--inactive';
      }
    }
  }

  /* ── Prices ── */
  function calcTotal() {
    var p = window.YMM_PRICES || { base: 0, express: 0, version: 0, wav: 0 };
    return p.base
      + (state.express ? p.express : 0)
      + (state.version ? p.version : 0)
      + (state.wav ? p.wav : 0);
  }

  function formatPrice(n) {
    return n.toFixed(2).replace('.', ',');
  }

  /* ── Summary ── */
  function updateSummary() {
    if (summaryIcon) summaryIcon.textContent = state.occasionEmoji || '\uD83C\uDFB5';
    if (summaryTitle) summaryTitle.textContent = (state.occasion || '') + ' voor ' + state.name;
    if (summaryDetails) {
      var genre = state.genre || state.customGenre || '';
      summaryDetails.textContent = state.lang + ' \u00B7 ' + genre + ' \u00B7 ' + (state.voice || '');
    }
    if (summaryStory) {
      var s = state.story.trim();
      summaryStory.textContent = s.length > 80 ? s.substring(0, 80) + '\u2026' : s;
    }

    /* Base price */
    var p = window.YMM_PRICES || { base: 0 };
    if (basePrice) basePrice.textContent = '\u20AC' + formatPrice(p.base);

    /* Bumps */
    bumpBtns.forEach(function (btn) {
      var key = btn.dataset.bump;
      btn.setAttribute('aria-pressed', state[key] ? 'true' : 'false');
    });

    updateTotal();
  }

  function updateTotal() {
    var total = calcTotal();
    if (totalAmount) totalAmount.textContent = '\u20AC' + formatPrice(total);
    updateCTA();
  }

  /* ── Chip Selection Helpers ── */
  function selectChip(chips, value, attr) {
    chips.forEach(function (c) {
      c.setAttribute('aria-pressed', c.dataset[attr] === value ? 'true' : 'false');
    });
  }

  /* ── Audio Player ── */
  var audioPlaying = false;

  function updateAudioPlayer() {
    if (!audioPlayer) return;

    /* Always stop current audio first before any source change */
    stopAudio();

    if (state.showCustomGenre || !state.genre) {
      audioPlayer.hidden = true;
      if (audioFallback) audioFallback.hidden = true;
      return;
    }

    var urls = window.YMM_AUDIO || {};
    var url = urls[state.genre];
    var hasAudio = url && url.trim().length > 0;

    if (hasAudio) {
      audioPlayer.hidden = false;
      if (audioFallback) audioFallback.hidden = true;
      if (audioGenreName) audioGenreName.textContent = state.genre;
      if (audioEl) audioEl.src = url;
      resetAudioUI();
    } else {
      audioPlayer.hidden = true;
      if (audioFallback) audioFallback.hidden = true;
    }
  }

  function stopAudio() {
    if (audioEl) {
      audioEl.pause();
      audioEl.removeAttribute('src');
      audioEl.load();
      if (window.YMMAudioManager) window.YMMAudioManager.stop(audioEl);
    }
    audioPlaying = false;
    updatePlayIcon(false);
  }

  function resetAudioUI() {
    audioPlaying = false;
    updatePlayIcon(false);
    if (audioBarFill) audioBarFill.style.width = '0%';
    if (audioTime) audioTime.textContent = '0:00 / 0:00';
  }

  function updatePlayIcon(playing) {
    if (!audioPlayBtn) return;
    if (playing) {
      audioPlayBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
      audioPlayBtn.setAttribute('aria-label', 'Pauzeer voorbeeld');
    } else {
      audioPlayBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="6,4 20,12 6,20"/></svg>';
      audioPlayBtn.setAttribute('aria-label', 'Speel ' + (state.genre || '') + ' af');
    }
  }

  function formatTime(sec) {
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  if (audioPlayBtn) {
    audioPlayBtn.addEventListener('click', function () {
      if (!audioEl || !audioEl.src) return;
      if (audioPlaying) {
        audioEl.pause();
        if (window.YMMAudioManager) window.YMMAudioManager.stop(audioEl);
      } else {
        if (window.YMMAudioManager) window.YMMAudioManager.play(audioEl);
        audioEl.play().catch(function () { });
      }
    });
  }

  if (audioEl) {
    if (window.YMMAudioManager) window.YMMAudioManager.register(audioEl, 'audio');

    audioEl.addEventListener('play', function () {
      audioPlaying = true;
      updatePlayIcon(true);
    });

    audioEl.addEventListener('pause', function () {
      audioPlaying = false;
      updatePlayIcon(false);
    });

    audioEl.addEventListener('timeupdate', function () {
      if (!audioEl.duration) return;
      var pct = (audioEl.currentTime / audioEl.duration) * 100;
      if (audioBarFill) audioBarFill.style.width = pct + '%';
      if (audioTime) audioTime.textContent = formatTime(audioEl.currentTime) + ' / ' + formatTime(audioEl.duration);
    });

    audioEl.addEventListener('ended', function () {
      if (audioBarFill) audioBarFill.style.width = '0%';
      audioEl.currentTime = 0;
      if (window.YMMAudioManager) window.YMMAudioManager.stop(audioEl);
    });
  }

  /* ── Character Counter (debounced) ── */
  var charTimer = null;

  function updateCharCount() {
    if (!charCount || !storyInput) return;
    var len = storyInput.value.length;

    if (len === 0) {
      charCount.textContent = '0/1000 \u00B7 verplicht';
      charCount.className = 'ymm-char-count ymm-char-count--low';
    } else if (len < 20) {
      charCount.textContent = len + '/1000 \u00B7 nog een paar woorden\u2026';
      charCount.className = 'ymm-char-count ymm-char-count--low';
    } else if (len < 100) {
      charCount.textContent = len + '/1000 \u00B7 meer = persoonlijker';
      charCount.className = 'ymm-char-count ymm-char-count--mid';
    } else {
      charCount.textContent = len + '/1000 \u2713';
      charCount.className = 'ymm-char-count ymm-char-count--good';
    }
  }

  /* ── Event Listeners ── */

  /* Progress dots — navigate back only */
  progressSteps.forEach(function (el, i) {
    el.addEventListener('click', function () {
      var target = i + 1;
      if (target < state.step) {
        goToStep(target, 'back');
      }
    });
  });

  /* CTA */
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      if (isSubmitting) return;

      if (!isStepValid(state.step)) {
        if (state.step === 4 && emailInput) {
          emailInput.classList.add('ymm-field__input--error');
          emailInput.focus({ preventScroll: true });
          emailInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { emailInput.classList.remove('ymm-field__input--error'); }, 2000);
        } else {
          ctaBtn.classList.add('ymm-shake');
          setTimeout(function () { ctaBtn.classList.remove('ymm-shake'); }, 400);
        }
        return;
      }

      if (state.step < 4) {
        goToStep(state.step + 1, 'forward');
      } else {
        submitOrder();
      }
    });
  }

  /* Step 1: Occasions */
  occasionChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var val = chip.dataset.occasion;

      if (val === 'Anders') {
        state.occasion = 'Anders';
        state.occasionEmoji = '\u2728';
        if (customOccasionWrap) customOccasionWrap.classList.add('ymm-custom-occasion--open');
      } else {
        state.occasion = val;
        state.occasionEmoji = occasionEmojis[val] || '';
        if (customOccasionWrap) customOccasionWrap.classList.remove('ymm-custom-occasion--open');
        state.customOccasion = '';
      }

      selectChip(occasionChips, val, 'occasion');
      saveState();
      updateCTA();
    });
  });

  /* Step 1: More occasions toggle */
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var open = moreWrap.classList.toggle('ymm-more-occasions--open');
      moreBtn.textContent = open ? '\u25B6 Minder opties' : '\u25B6 Meer gelegenheden';
    });
  }

  /* Step 1: Custom occasion */
  if (customOccasionInput) {
    customOccasionInput.addEventListener('input', function () {
      state.customOccasion = this.value;
      saveState();
    });
  }

  /* Step 1: Name */
  if (nameInput) {
    nameInput.addEventListener('input', function () {
      state.name = this.value;
      saveState();
      updateCTA();
    });
  }

  /* Step 2: Language */
  langChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      state.lang = chip.dataset.lang;
      selectChip(langChips, state.lang, 'lang');
      saveState();
    });
  });

  /* Step 2: Genre */
  genreChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      state.genre = chip.dataset.genre;
      state.showCustomGenre = false;
      state.customGenre = '';
      selectChip(genreChips, state.genre, 'genre');
      if (customGenreWrap) customGenreWrap.classList.remove('ymm-custom-genre--open');
      if (customGenreBtn) customGenreBtn.textContent = '\u25B6 Ik wil een andere stijl';
      updateAudioPlayer();
      saveState();
      updateCTA();
    });
  });

  /* Step 2: Custom genre toggle */
  if (customGenreBtn) {
    customGenreBtn.addEventListener('click', function () {
      if (state.showCustomGenre) {
        state.showCustomGenre = false;
        state.customGenre = '';
        customGenreWrap.classList.remove('ymm-custom-genre--open');
        customGenreBtn.textContent = '\u25B6 Ik wil een andere stijl';
      } else {
        state.showCustomGenre = true;
        state.genre = null;
        selectChip(genreChips, '', 'genre');
        customGenreWrap.classList.add('ymm-custom-genre--open');
        customGenreBtn.textContent = '\u25B6 Kies toch een stijl hierboven';
        if (customGenreInput) customGenreInput.focus();
      }
      updateAudioPlayer();
      saveState();
      updateCTA();
    });
  }

  /* Step 2: Custom genre input */
  if (customGenreInput) {
    customGenreInput.addEventListener('input', function () {
      state.customGenre = this.value;
      saveState();
      updateCTA();
    });
  }

  /* Step 2: Voice */
  voiceChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      state.voice = chip.dataset.voice;
      selectChip(voiceChips, state.voice, 'voice');
      saveState();
      updateCTA();
    });
  });

  /* Step 3: Story */
  if (storyInput) {
    storyInput.addEventListener('input', function () {
      state.story = this.value;
      saveState();

      clearTimeout(charTimer);
      charTimer = setTimeout(updateCharCount, 80);
      updateCTA();
    });
  }

  /* Step 3: Extras toggle */
  if (extrasBtn) {
    extrasBtn.addEventListener('click', function () {
      var open = extrasWrap.classList.toggle('ymm-extras-wrap--open');
      extrasBtn.textContent = open ? '\u25B6 Verberg extra opties' : '\u25B6 Specifieke woorden of zinnen (optioneel)';
      if (open && extrasInput) extrasInput.focus();
    });
  }

  /* Step 3: Extras input */
  if (extrasInput) {
    extrasInput.addEventListener('input', function () {
      state.extras = this.value;
      saveState();
    });
  }

  /* Step 4: Bumps */
  bumpBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.bump;
      state[key] = !state[key];
      btn.setAttribute('aria-pressed', state[key] ? 'true' : 'false');
      saveState();
      updateTotal();
    });
  });

  /* Step 4: Email */
  if (emailInput) {
    emailInput.addEventListener('input', function () {
      state.email = this.value;
      saveState();
      updateCTA();
    });
  }

  /* ── Submit Order ── */
  function showError(msg) {
    if (errorMsg) {
      errorMsg.textContent = msg;
      errorMsg.hidden = false;
    }
  }

  function hideError() {
    if (errorMsg) errorMsg.hidden = true;
  }

  function submitOrder() {
    if (isSubmitting) return;
    isSubmitting = true;
    hideError();

    /* Validate all previous steps before submitting */
    for (var s = 1; s <= 3; s++) {
      if (!isStepValid(s)) {
        showError('Niet alle stappen zijn volledig ingevuld.');
        isSubmitting = false;
        return;
      }
    }

    var variants = window.YMM_VARIANTS || {};
    if (!variants.main) {
      showError('Product niet geconfigureerd. Neem contact op.');
      isSubmitting = false;
      return;
    }

    /* Loading state */
    ctaBtn.textContent = 'Laden\u2026';
    ctaBtn.className = 'ymm-cta-btn ymm-cta-btn--active ymm-cta-btn--loading';
    ctaBtn.disabled = true;

    /* Build properties — filter empty values */
    var properties = {
      'Gelegenheid': state.occasion || '',
      'Voor': state.name,
      'Taal': state.lang,
      'Muziekstijl': state.genre || state.customGenre || '',
      'Stemvoorkeur': state.voice || '',
      'Verhaal': state.story,
      '_attribution': 'wizard-v7'
    };

    if (state.customOccasion) properties['Aangepaste gelegenheid'] = state.customOccasion;
    if (state.customGenre) properties['Aangepaste stijl'] = state.customGenre;
    if (state.extras) properties['Specifieke woorden'] = state.extras;
    if (state.email) properties['E-mail levering'] = state.email;

    /* Remove empty values (safe type check) */
    var cleanProps = {};
    for (var pKey in properties) {
      var val = properties[pKey];
      if (val && typeof val === 'string' && val.trim().length > 0) {
        cleanProps[pKey] = val;
      }
    }

    /* Build items */
    var items = [];
    items.push({ id: variants.main, quantity: 1, properties: cleanProps });
    if (state.express && variants.express) items.push({ id: variants.express, quantity: 1 });
    if (state.version && variants.version) items.push({ id: variants.version, quantity: 1 });
    if (state.wav && variants.wav) items.push({ id: variants.wav, quantity: 1 });

    /* Build cart-level attributes (become note_attributes on the order) */
    var cartAttributes = {
      'Gelegenheid': state.occasion || state.customOccasion || '',
      'Voor': state.name,
      'Taal': state.lang,
      'Muziekstijl': state.genre || state.customGenre || '',
      'Stemvoorkeur': state.voice || '',
      'Verhaal': state.story
    };

    /* Clear cart → add items → set cart attributes → redirect */
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Clear cart failed');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: cartAttributes })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart attributes failed');
        /* Keep wizard data in localStorage so user can return to filled-in steps */
        var checkoutUrl = '/checkout';
        if (state.email) {
          checkoutUrl += '?checkout[email]=' + encodeURIComponent(state.email);
        }
        window.location.href = checkoutUrl;
      })
      .catch(function () {
        isSubmitting = false;
        showError('Er ging iets mis. Probeer het opnieuw.');
        var total = calcTotal();
        ctaBtn.textContent = 'Bestel nu \u2014 \u20AC' + formatPrice(total);
        ctaBtn.className = 'ymm-cta-btn ymm-cta-btn--active';
        ctaBtn.disabled = false;
      });
  }

  /* ── Restore UI from State ── */
  function restoreUI() {
    /* Occasion */
    if (state.occasion) selectChip(occasionChips, state.occasion, 'occasion');
    if (state.occasion === 'Anders' && customOccasionWrap) {
      customOccasionWrap.classList.add('ymm-custom-occasion--open');
    }
    if (customOccasionInput) customOccasionInput.value = state.customOccasion;

    /* Open 'more occasions' if selected occasion is in the expanded section */
    if (state.occasion && moreWrap) {
      var moreChips = moreWrap.querySelectorAll('[data-occasion]');
      for (var mi = 0; mi < moreChips.length; mi++) {
        if (moreChips[mi].dataset.occasion === state.occasion) {
          moreWrap.classList.add('ymm-more-occasions--open');
          if (moreBtn) moreBtn.textContent = '\u25B6 Minder opties';
          break;
        }
      }
    }

    if (nameInput) nameInput.value = state.name;

    /* Language */
    selectChip(langChips, state.lang, 'lang');

    /* Genre */
    if (state.showCustomGenre) {
      selectChip(genreChips, '', 'genre');
      if (customGenreWrap) customGenreWrap.classList.add('ymm-custom-genre--open');
      if (customGenreBtn) customGenreBtn.textContent = '\u25B6 Kies toch een stijl hierboven';
    } else if (state.genre) {
      selectChip(genreChips, state.genre, 'genre');
    }
    if (customGenreInput) customGenreInput.value = state.customGenre;

    /* Voice */
    if (state.voice) selectChip(voiceChips, state.voice, 'voice');

    /* Story */
    if (storyInput) storyInput.value = state.story;
    updateCharCount();

    /* Extras */
    if (extrasInput) extrasInput.value = state.extras;
    if (state.extras && extrasWrap) {
      extrasWrap.classList.add('ymm-extras-wrap--open');
      if (extrasBtn) extrasBtn.textContent = '\u25B6 Verberg extra opties';
    }

    /* Bumps */
    bumpBtns.forEach(function (btn) {
      btn.setAttribute('aria-pressed', state[btn.dataset.bump] ? 'true' : 'false');
    });

    /* Email */
    if (emailInput) emailInput.value = state.email;

    /* Step */
    steps.forEach(function (s, i) {
      s.classList.toggle('ymm-step--active', i + 1 === state.step);
      if (i + 1 === state.step) {
        s.style.opacity = '1';
        s.style.transform = 'none';
      }
    });

    updateProgress();
    updateCTA();
    updateCard();
    updateAudioPlayer();

    if (state.step === 4) updateSummary();
  }

  /* ── Subtext updates for steps 2 and 3 ── */
  function updateSubtexts() {
    var sub2 = root.querySelector('[data-sub="step2"]');
    var sub3 = root.querySelector('[data-sub="step3"]');
    var n = state.name || 'je liedje';
    if (sub2) sub2.innerHTML = 'Kies taal, stijl en stem voor <span class="ymm-teal">' + escHtml(n) + '</span>';
    if (sub3) sub3.innerHTML = 'Wat maakt <span class="ymm-teal">' + escHtml(n) + '</span> speciaal?';
  }

  function escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* Update subtexts on name change */
  if (nameInput) {
    nameInput.addEventListener('input', function () {
      updateSubtexts();
    });
  }

  /* ── Init ── */
  restoreUI();
  updateSubtexts();

})();
